import React, { Component } from 'react';
import { withRouter, Link } from 'react-router-dom';
import {
    Grid,
    FormControl,
    CardHeader,
    Typography,
    Fab,
    CardContent,
    Button,
    Table,
    TableContainer,
    Paper,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    CircularProgress
} from '@material-ui/core';
import ArrowBack from '@material-ui/icons/ArrowBack';
import moment from 'moment'
import { withSnackbar } from 'notistack';
import { withTranslation } from 'react-i18next';
import WrappedAutocomplete from 'common/components/custom/WrappedAutocomplete';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import { getEmployeeHistory, getLocationHistory } from '../../api/apiAsset';
import { getEmployeesSimple } from 'views/employee/api/apiEmployee';
import { getLocationsSimple } from 'views/location/api/apiLocation';
import { createAssetEmployeeHistory, createAssetLocationHistory, deleteEmployeeHistory, deleteLocationHistory, updateAssetEmployeeHistory, updateAssetLocationHistory } from '../../api/apiHistory';
import ConfirmationDialog from 'common/components/ConfirmationDialog';
import AssetHistoryEmployeeEditDialog from './AssetHistoryEmployeeEditDialog';
import AssetHistoryLocationEditDialog from './AssetHistoryLocationEditDialog';
import WrappedKeyboardDatePicker from 'common/components/custom/WrappedKeyboardDatePicker';

class AssetHistory extends Component {

    emptyEmployeeHistory = {
        startDate: '',
        employeeId: null,
        issuedById: null
    }

    emptyLocationHistory = {
        startDate: '',
        locationId: null
    }

    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            employeeHistory: this.emptyEmployeeHistory,
            employeeHistoryEdit: this.emptyEmployeeHistory,
            locationHistory: this.emptyLocationHistory,
            locationHistoryEdit: this.emptyLocationHistory,
            selectedLocation: null,
            selectedIssuedBy: null,
            selectedEmployee: null,
            locationsHistory: [],
            employeesHistory: [],
            selectedEmployeeStartDate: null,
            selectedLocationStartDate: null,
            selectedClient: props.location.state && props.location.state.selectedClient ? props.location.state.selectedClient : null,
            selectedInventory: props.location.state && props.location.state.selectedInventory ? props.location.state.selectedInventory : null,
            selectedReportingYear: props.location.state && props.location.state.selectedReportingYear ? props.location.state.selectedReportingYear : null,
            inactiveAssets: props.location.state && props.location.state.inactiveAssets ? props.location.state.inactiveAssets : false,
            inventoryNumber: props.location.state && props.location.state.inventoryNumber ? props.location.state.inventoryNumber : null,
            assetName: props.location.state && props.location.state.assetName ? props.location.state.assetName : null,
            employees: [],
            locations: [],
            employeeHistoryDeleteDialog: false,
            employeeHistoryToDelete: null,
            locationHistoryDialog: false,
            locationHistoryToDelete: null,
            editEmployeeHistory: null,
            employeeHistoryEditDialog: false,
            selectedEmployeeEdit: null,
            selectedIssuedByEdit: null,
            selectedEmployeeStartDateEdit: null,
            assetLocationEditDialog: false,
            selectedLocationEdit: null,
            selectedLocationStartDateEdit: null,
            selectedFrom: props.location.state && props.location.state.selectedFrom ? props.location.state.selectedFrom : null,
            selectedTo: props.location.state && props.location.state.selectedTo ? props.location.state.selectedTo : null
        };
    }

    async componentDidMount() {
        Promise.all([this.getEmployeeHistory(), this.getLocationHistory(), this.getEmployeesSimple(), this.getLocationsSimple()])
            .then(() => {
                this.setState({ isLoading: false })

            })
            .catch(error => {
                console.log('Promise rejected:', error);
            })
    }

    getEmployeeHistory = () => {
        getEmployeeHistory(this.props.match.params.id).then(response => {
            /*  let { employeeHistoryEdit } = this.state
             employeeHistoryEdit.employeeId = response.data.data.employee.id
             employeeHistoryEdit.issuedById = response.data.data.issuedBy.id */
            this.setState({ employeesHistory: response.data.data/* , employeeHistoryEdit : employeeHistoryEdit */ });
        }).catch(error => {
            this.props.enqueueSnackbar(this.props.t("error_get_employee_history"), { variant: 'error' });
        });
    }

    getLocationHistory = () => {
        getLocationHistory(this.props.match.params.id).then(response => {
            this.setState({ locationsHistory: response.data.data });
        }).catch(error => {
            this.props.enqueueSnackbar(this.props.t("error_get_location_history"), { variant: 'error' });
        });
    }

    getEmployeesSimple = () => {
        getEmployeesSimple(this.state.selectedClient.id).then((response) => {
            this.setState({ employees: response.data.data });
        }).catch(error => {
            this.props.enqueueSnackbar(this.props.t("something_went_wrong"), { variant: 'error' });
        });
    }

    getLocationsSimple = () => {
        getLocationsSimple(this.state.selectedClient.id).then((response) => {
            this.setState({ locations: response.data.data });
        }).catch(error => {
            this.props.enqueueSnackbar(this.props.t("something_went_wrong"), { variant: 'error' });
        });
    }

    handleChangeEmployeeStartDate = (date) => {
        let { employeeHistory } = this.state;
        employeeHistory.startDate = moment(date).format("DD-MM-YYYY");
        this.setState({ employeeHistory: employeeHistory, selectedEmployeeStartDate: date })
    }

    handleChangeEmployeeEditStartDate = (date) => {
        let { employeeHistoryEdit } = this.state;
        employeeHistoryEdit.startDate = date !== null ? moment(date).format("DD-MM-YYYY") : "";
        this.setState({ employeeHistoryEdit: employeeHistoryEdit, selectedEmployeeStartDateEdit: date })
    }


    handleChangeLocationStartDate = (date) => {
        let { locationHistory } = this.state;
        locationHistory.startDate = moment(date).format("DD-MM-YYYY");
        this.setState({ locationHistory: locationHistory, selectedLocationStartDate: date })
    }

    handleChangeLocationEditStartDate = (date) => {
        let { locationHistoryEdit } = this.state;
        locationHistoryEdit.startDate = date !== null ? moment(date).format("DD-MM-YYYY") : "";
        this.setState({ locationHistoryEdit: locationHistoryEdit, selectedLocationStartDateEdit: date })
    }

    handleChangeLocation = (location) => {
        let { locationHistory } = this.state
        if (location !== null) {
            locationHistory.locationId = location.id
            this.setState({ selectedLocation: location, locationHistory: locationHistory })
        } else {
            locationHistory.locationId = null
            this.setState({ selectedLocation: null, locationHistory: locationHistory })
        }
    }

    handleChangeLocationEdit = (location) => {
        let { locationHistoryEdit } = this.state
        if (location !== null) {
            locationHistoryEdit.locationId = location.id
            this.setState({ selectedLocationEdit: location, locationHistoryEdit: locationHistoryEdit })
        } else {
            locationHistoryEdit.locationId = null
            this.setState({ selectedLocationEdit: null, locationHistoryEdit: locationHistoryEdit })
        }
    }

    handleChangeEmployee = (employee) => {
        let { employeeHistory } = this.state
        if (employee !== null) {
            employeeHistory.employeeId = employee.id
            this.setState({ selectedEmployee: employee, employeeHistory: employeeHistory })
        } else {
            employeeHistory.employeeId = null
            this.setState({ selectedEmployee: null, employeeHistory: employeeHistory })
        }
    }

    handleChangeEmployeeEdit = (employee) => {
        let { employeeHistoryEdit } = this.state
        if (employee !== null) {
            employeeHistoryEdit.employeeId = employee.id
            this.setState({ selectedEmployeeEdit: employee, employeeHistoryEdit: employeeHistoryEdit })
        } else {
            employeeHistoryEdit.employeeId = null
            this.setState({ selectedEmployeeEdit: null, employeeHistoryEdit: employeeHistoryEdit })
        }
    }

    handleChangeIssuedBy = (employee) => {
        let { employeeHistory } = this.state
        if (employee !== null) {
            employeeHistory.issuedById = employee.id
            this.setState({ selectedIssuedBy: employee, employeeHistory: employeeHistory })
        } else {
            employeeHistory.issuedById = null
            this.setState({ selectedIssuedBy: null, employeeHistory: employeeHistory })
        }
    }

    handleChangeIssuedByEdit = (employee) => {
        let { employeeHistoryEdit } = this.state
        if (employee !== null) {
            employeeHistoryEdit.issuedById = employee.id
            this.setState({ selectedIssuedByEdit: employee, employeeHistoryEdit: employeeHistoryEdit })
        } else {
            employeeHistoryEdit.issuedById = null
            this.setState({ selectedIssuedByEdit: null, employeeHistoryEdit: employeeHistoryEdit })
        }
    }

    createAssetEmployeeHistory = () => {
        let { employeeHistory } = this.state
        createAssetEmployeeHistory(this.props.match.params.id, employeeHistory).then(response => {
            this.props.enqueueSnackbar(this.props.t('create_message_asset_employee_history'), { variant: 'success' });
            this.getEmployeeHistory()
            this.setState({ selectedEmployeeStartDate: null, selectedIssuedBy: null, selectedEmployee: null })
        }).catch(error => {
            this.props.enqueueSnackbar(this.props.t('error_create_message', { title: this.props.t('asset_employee_history') }), { variant: 'error' });
        });
    }

    createAssetLocationHistory = () => {
        let { locationHistory } = this.state
        createAssetLocationHistory(this.props.match.params.id, locationHistory).then(response => {
            this.props.enqueueSnackbar(this.props.t('create_message_asset_location_history'), { variant: 'success' });
            this.getLocationHistory()
            this.setState({ selectedLocationStartDate: null, selectedLocation: null })
        }).catch(error => {
            this.props.enqueueSnackbar(this.props.t('error_create_message', { title: this.props.t('asset_location_history') }), { variant: 'error' });
        });
    }

    updateEmployeeHistory = (e) => {
        e.preventDefault()
        let { employeeHistoryEdit, assetEmployeeId } = this.state
        employeeHistoryEdit.employeeId = this.state.selectedEmployeeEdit !== null ? this.state.selectedEmployeeEdit.id : null
        employeeHistoryEdit.issuedById = this.state.selectedIssuedByEdit !== null ? this.state.selectedIssuedByEdit.id : null
        employeeHistoryEdit.startDate = this.state.selectedEmployeeStartDateEdit !== null ? moment(this.state.selectedEmployeeStartDateEdit, "DD-MM-YYYY").format("DD-MM-YYYY") : ""
        this.setState({ employeeHistoryEdit: employeeHistoryEdit })

        updateAssetEmployeeHistory(assetEmployeeId, employeeHistoryEdit).then(response => {
            this.props.enqueueSnackbar(this.props.t('update_message_asset_employee_history'), { variant: 'success' });
            this.getEmployeeHistory()
            this.closeEmployeeHistoryDialog()
        }).catch(error => {
            this.props.enqueueSnackbar(this.props.t('error_update_message', { title: this.props.t('asset_employee_history') }), { variant: 'error' });
        });
    }

    updateLocationHistory = (e) => {
        e.preventDefault()
        let { assetLocationId, locationHistoryEdit } = this.state
        locationHistoryEdit.startDate = this.state.selectedLocationStartDateEdit !== null ? moment(this.state.selectedLocationStartDateEdit, "DD-MM-YYYY").format("DD-MM-YYYY") : ""
        locationHistoryEdit.locationId = this.state.selectedLocationEdit !== null ? this.state.selectedLocationEdit.id : null
        this.setState({ locationHistoryEdit: locationHistoryEdit })

        updateAssetLocationHistory(assetLocationId, locationHistoryEdit).then(response => {
            this.props.enqueueSnackbar(this.props.t('update_message_asset_location_history'), { variant: 'success' });
            this.getLocationHistory()
            this.closeLocationHistoryDialog()
        }).catch(error => {
            this.props.enqueueSnackbar(this.props.t('error_update_message', { title: this.props.t('asset_location_history') }), { variant: 'error' });
        });
    }

    deleteAssetEmployeeHistory = () => {
        let { employeeHistoryToDelete } = this.state
        deleteEmployeeHistory(employeeHistoryToDelete.id).then(response => {
            this.props.enqueueSnackbar(this.props.t("delete_message_asset_employee_history"), { variant: 'success' });
            this.setState({ employeeHistoryDeleteDialog: false, employeeHistoryToDelete: null });
            this.getEmployeeHistory()
        }).catch(error => {
            console.log(error)
            this.props.enqueueSnackbar(this.props.t("error_delete_asset_employee_history"), { variant: 'error' });
        });
    }

    deleteAssetLocationHistory = () => {
        let { locationHistoryToDelete } = this.state
        deleteLocationHistory(locationHistoryToDelete.id).then(response => {
            this.props.enqueueSnackbar(this.props.t("delete_message_asset_location_history"), { variant: 'success' });
            this.setState({ locationHistoryDialog: false, locationHistoryToDelete: null });
            this.getLocationHistory()
        }).catch(error => {
            console.log(error)
            this.props.enqueueSnackbar(this.props.t("error_delete_asset_location_history"), { variant: 'error' });
        });
    }

    closeEmployeeHistoryDialog = () => {
        this.setState({ employeeHistoryEditDialog: false, selectedEmployeeStartDateEdit: null, selectedEmployeeEdit: null, selectedIssuedByEdit: null })
    }

    closeLocationHistoryDialog = () => {
        this.setState({ assetLocationEditDialog: false })
    }

    render() {
        let { isLoading, locationsHistory, employeesHistory, selectedEmployeeStartDate, selectedLocationStartDate, selectedEmployee, selectedIssuedBy, employees, locations, selectedLocation, employeeHistoryToDelete, employeeHistoryDeleteDialog, locationHistoryDialog, locationHistoryToDelete, employeeHistoryEditDialog, selectedEmployeeEdit, selectedIssuedByEdit, selectedEmployeeStartDateEdit, selectedLocationStartDateEdit, selectedLocationEdit, assetLocationEditDialog, locationHistoryEdit, employeeHistoryEdit } = this.state
        let { t } = this.props

        if (isLoading) {
            return (
                <div className="loading-position">
                    <CircularProgress className="spinner" color="primary" />
                </div>
            )
        }

        const disabledAddEmployee = selectedEmployeeStartDate && selectedIssuedBy
        const disabledAddLocation = selectedLocationStartDate && selectedLocation
        const disabledEmployeeEditButton = employeeHistoryEdit.startDate === "" && employeeHistoryEdit.employeeId === null && employeeHistoryEdit.issuedById === null
        const disabledLocationEditButton = locationHistoryEdit.startDate === "" && locationHistoryEdit.locationId === null

        let employeesHistoryList;
        let recordsNotFoundEmployeeList;
        if (employeesHistory && employeesHistory.length > 0) {
            employeesHistoryList = employeesHistory.map((employeeHistory, index) => {
                return <TableRow key={index}>
                    <TableCell>{employeeHistory.startDate}</TableCell>
                    <TableCell>{employeeHistory.employee && employeeHistory.employee.email}</TableCell>
                    <TableCell>{employeeHistory.issuedBy && employeeHistory.issuedBy.email}</TableCell>
                    <TableCell>
                        <Fab title={this.props.t("edit")} size="small" style={{ marginRight: 10 }} color="secondary" aria-label="edit"
                            onClick={() => this.setState({
                                assetEmployeeId: employeeHistory.id,
                                selectedEmployeeStartDateEdit: employeeHistory.startDate,
                                selectedEmployeeEdit: employeeHistory.employee,
                                selectedIssuedByEdit: employeeHistory.issuedBy,
                                employeeHistoryEditDialog: true
                            })}>
                            <EditIcon />
                        </Fab>
                        <Fab title={this.props.t("delete")} size="small" style={{ marginRight: 10 }} color="inherit" aria-label="delete" onClick={() => this.setState({ employeeHistoryToDelete: employeeHistory, employeeHistoryDeleteDialog: true })}>
                            <DeleteIcon />
                        </Fab>
                    </TableCell>
                </TableRow >
            });
        } else {
            recordsNotFoundEmployeeList = <TableRow>
                <TableCell align="center" colSpan={6}>
                    <p>{this.props.t("no_records_found")}</p>
                </TableCell>
            </TableRow>
        }

        let locationsHistoryList;
        let recordsNotFoundLocationList;
        if (locationsHistory && locationsHistory.length > 0) {
            locationsHistoryList = locationsHistory.map((locationHistory, index) => {
                return <TableRow key={index}>
                    <TableCell>{locationHistory.startDate}</TableCell>
                    <TableCell>{locationHistory.location && locationHistory.location.address}</TableCell>
                    <TableCell>{locationHistory.location && locationHistory.location.floor}</TableCell>
                    <TableCell>{locationHistory.location && locationHistory.location.room}</TableCell>
                    <TableCell>{locationHistory.location && locationHistory.location.city}</TableCell>
                    <TableCell>
                        <Fab title={this.props.t("edit")} size="small" style={{ marginRight: 10 }} color="secondary" aria-label="edit" onClick={() => this.setState({ assetLocationId: locationHistory.id, selectedLocationStartDateEdit: locationHistory.startDate, selectedLocationEdit: locationHistory.location, assetLocationEditDialog: true })}>
                            <EditIcon />
                        </Fab>
                        <Fab title={this.props.t("delete")} size="small" style={{ marginRight: 10 }} color="inherit" aria-label="delete" onClick={() => this.setState({ locationHistoryToDelete: locationHistory, locationHistoryDialog: true })}>
                            <DeleteIcon />
                        </Fab>
                    </TableCell>
                </TableRow >
            });
        } else {
            recordsNotFoundLocationList = <TableRow>
                <TableCell align="center" colSpan={6}>
                    <p>{this.props.t("no_records_found")}</p>
                </TableCell>
            </TableRow>
        }

        let employeesList = []
        let notAssignedObject = { id: null, firstName: 'Not', lastName: 'Assigned', email: '' };
        employees.map(data => {
            return employeesList.push(data)
        })
        employeesList.push(notAssignedObject)
        employeesList.sort((a, b) => (a > b) ? 1 : -1)

        return (
            <Grid container direction="row" spacing={2}>
                <Grid item container direction="column" xs={12} sm={12} md={12} lg={12} xl={12}>
                    <CardHeader
                        style={{ height: '62px' }}
                        title={<Typography variant={"h6"}>{t("asset")}{ }{" " + this.state.assetName} {", " + this.state.inventoryNumber}</Typography>}
                        avatar={
                            <Fab
                                size="small"
                                color="secondary"
                                component={Link}
                                to={{
                                    pathname: this.state.inactiveAssets ? `/inactive-assets` : `/assets`,
                                    state: {
                                        selectedInventory: this.state.selectedInventory,
                                        selectedReportingYear: this.state.selectedReportingYear,
                                        selectedClient: this.state.selectedClient,
                                        selectedFrom: this.state.selectedFrom,
                                        selectedTo: this.state.selectedTo,
                                        inactiveAssets: this.state.inactiveAssets
                                    }
                                }}
                            >
                                <ArrowBack />
                            </Fab>
                        } />
                    <CardContent>
                        <Grid container direction="row" spacing={2}>
                            <Grid item container direction="column" xs={6} sm={6} md={6} lg={6} xl={6} style={{ borderRight: '2px solid grey' }}>
                                <Grid container direction="row" spacing={2}>
                                    <Grid item container direction="column" xs={6} sm={6} md={6} lg={6} xl={6}>
                                        <Grid container direction="row">
                                            <Typography variant="h5">{this.props.t("employees")}</Typography>
                                        </Grid>
                                    </Grid>
                                    <Grid item container direction="column" xs={6} sm={6} md={6} lg={6} xl={6} >
                                        <Grid container direction="row" justifyContent="flex-end">
                                            <Button variant="contained" color="secondary" onClick={() => this.createAssetEmployeeHistory()} disabled={!disabledAddEmployee}>
                                                {this.props.t("add_new")}
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <br />
                                <Grid container direction="row" spacing={2}>
                                    <Grid item container direction="column" xs={6} sm={6} md={6} lg={6} xl={6}>
                                        <WrappedKeyboardDatePicker
                                            name="selectedEmployeeStartDate"
                                            label={this.props.t("starting_date_of_usage")}
                                            value={selectedEmployeeStartDate ? moment(selectedEmployeeStartDate, "DD-MM-YYYY") : null}
                                            onChange={this.handleChangeEmployeeStartDate}
                                        />
                                    </Grid>
                                    <Grid item container direction="column" xs={9} sm={9} md={9} lg={9} xl={9}>
                                        <FormControl variant="outlined" fullWidth>
                                            <WrappedAutocomplete
                                                label={this.props.t("employee")}
                                                placeholder={this.props.t("employee")}
                                                name="selectedEmployee"
                                                value={selectedEmployee}
                                                options={employeesList}
                                                onChange={this.handleChangeEmployee}
                                                getOptionLabel={option => option.firstName && option.email ? option.firstName + " " + option.lastName + ", " + option.email : option.email ? option.firstName + " " + option.lastName + ", " + option.email : option.firstName + " " + option.lastName}
                                                getOptionSelected={(option, value) => option.id === value.id}
                                                renderOption={option => (
                                                    <React.Fragment>
                                                        {option.firstName && option.email ? option.firstName + " " + option.lastName + ", " + option.email : option.email ? option.firstName + " " + option.lastName + ", " + option.email : option.firstName + " " + option.lastName}
                                                    </React.Fragment>
                                                )}
                                            />
                                        </FormControl>
                                    </Grid>
                                    <Grid item container direction="column" xs={9} sm={9} md={9} lg={9} xl={9}>
                                        <FormControl variant="outlined" fullWidth>
                                            <WrappedAutocomplete
                                                label={this.props.t("issued_by")}
                                                placeholder={this.props.t("issued_by")}
                                                name="selectedIssuedBy"
                                                value={selectedIssuedBy}
                                                options={employeesList}
                                                onChange={this.handleChangeIssuedBy}
                                                getOptionLabel={option => option.firstName && option.email ? option.firstName + " " + option.lastName + ", " + option.email : option.email ? option.firstName + " " + option.lastName + ", " + option.email : option.firstName + " " + option.lastName}
                                                getOptionSelected={(option, value) => option.id === value.id}
                                                renderOption={option => (
                                                    <React.Fragment>
                                                        {option.firstName && option.email ? option.firstName + " " + option.lastName + ", " + option.email : option.email ? option.firstName + " " + option.lastName + ", " + option.email : option.firstName + " " + option.lastName}
                                                    </React.Fragment>
                                                )}
                                            />
                                        </FormControl>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item container direction="column" xs={6} sm={6} md={6} lg={6} xl={6} style={{ borderLeft: '2px solid grey' }}>
                                <Grid container direction="row" spacing={2}>
                                    <Grid item container direction="column" xs={4} sm={4} md={4} lg={4} xl={4}>
                                        <Grid container direction="row">
                                            <Typography variant="h5">{this.props.t("locations")}</Typography>
                                        </Grid>
                                    </Grid>
                                    <Grid item container direction="column" xs={8} sm={8} md={8} lg={8} xl={8} >
                                        <Grid container direction="row" justifyContent="flex-end">
                                            <Button variant="contained" color="secondary" onClick={() => this.createAssetLocationHistory()} disabled={!disabledAddLocation}>
                                                {this.props.t("add_new")}
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <br />
                                <Grid container direction="row" spacing={2}>
                                    <Grid item container direction="column" xs={8} sm={8} md={8} lg={8} xl={8}>
                                        <WrappedKeyboardDatePicker
                                            name="selectedLocationStartDate"
                                            label={this.props.t("starting_date_of_usage")}
                                            value={selectedLocationStartDate ? moment(selectedLocationStartDate, "DD-MM-YYYY") : null}
                                            onChange={this.handleChangeLocationStartDate}
                                        />
                                    </Grid>
                                    <Grid item container direction="column" xs={10} sm={10} md={10} lg={10} xl={10}>
                                        <FormControl variant="outlined" fullWidth>
                                            <WrappedAutocomplete
                                                label={"location"}
                                                placeholder={this.props.t("location")}
                                                name="location"
                                                value={selectedLocation}
                                                options={locations}
                                                onChange={this.handleChangeLocation}
                                                getOptionLabel={option => option.address ? option.address + ", " + this.props.t("floor") + " : " + option.floor + ", " + this.props.t("room") + " : " + option.room : ""}
                                                getOptionSelected={(option, value) => option.id === value.id}
                                                renderOption={option => (
                                                    <React.Fragment>
                                                        {option.address ? option.address + ", " + this.props.t("floor") + " : " + option.floor + ", " + this.props.t("room") + " : " + option.room : ""}
                                                    </React.Fragment>
                                                )}
                                            />
                                        </FormControl>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                        <br />
                        <Grid container direction="row" spacing={2}>
                            <Grid item container direction="column" xs={6} sm={6} md={6} lg={6} xl={6}>
                                <Grid container direction="row" spacing={2}>
                                    <Grid item container>
                                        <TableContainer component={Paper}>
                                            <Table aria-label="simple table" size="small">
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell component="th" scope="row" width="20%">{this.props.t("start_usage")}</TableCell>
                                                        <TableCell component="th" scope="row" width="30%">{this.props.t("employee")}</TableCell>
                                                        <TableCell component="th" scope="row" width="30%">{this.props.t("issued_by")}</TableCell>
                                                        <TableCell component="th" scope="row" width="20%"></TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {employeesHistoryList}
                                                    {recordsNotFoundEmployeeList}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item container direction="column" xs={6} sm={6} md={6} lg={6} xl={6}>
                                <Grid container direction="row" spacing={2}>
                                    <Grid item container>
                                        <TableContainer component={Paper}>
                                            <Table aria-label="simple table" size="small">
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell component="th" scope="row" width="20%">{this.props.t("start_date")}</TableCell>
                                                        <TableCell component="th" scope="row" width="20%">{this.props.t("address")}</TableCell>
                                                        <TableCell component="th" scope="row" width="10%">{this.props.t("floor")}</TableCell>
                                                        <TableCell component="th" scope="row" width="10%">{this.props.t("room")}</TableCell>
                                                        <TableCell component="th" scope="row" width="20%">{this.props.t("city")}</TableCell>
                                                        <TableCell component="th" scope="row" width="20%"></TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {locationsHistoryList}
                                                    {recordsNotFoundLocationList}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                        <AssetHistoryEmployeeEditDialog
                            employeesList={employeesList}
                            employeeHistoryEditDialog={employeeHistoryEditDialog}
                            updateEmployeeHistory={this.updateEmployeeHistory}
                            handleChangeEmployeeEdit={this.handleChangeEmployeeEdit}
                            handleChangeIssuedByEdit={this.handleChangeIssuedByEdit}
                            handleChangeEmployeeEditStartDate={this.handleChangeEmployeeEditStartDate}
                            selectedEmployeeEdit={selectedEmployeeEdit}
                            selectedEmployeeStartDateEdit={selectedEmployeeStartDateEdit}
                            selectedIssuedByEdit={selectedIssuedByEdit}
                            closeEmployeeHistoryDialog={this.closeEmployeeHistoryDialog}
                            disabledEmployeeEditButton={disabledEmployeeEditButton}
                        />
                        <AssetHistoryLocationEditDialog
                            assetLocationEditDialog={assetLocationEditDialog}
                            selectedLocationStartDateEdit={selectedLocationStartDateEdit}
                            locations={locations}
                            emptyLocationHistory={this.emptyLocationHistory}
                            selectedLocationEdit={selectedLocationEdit}
                            updateLocationHistory={this.updateLocationHistory}
                            closeLocationHistoryDialog={this.closeLocationHistoryDialog}
                            handleChangeLocationEditStartDate={this.handleChangeLocationEditStartDate}
                            handleChangeLocationEdit={this.handleChangeLocationEdit}
                            disabledLocationEditButton={disabledLocationEditButton}
                        />
                    </CardContent>
                </Grid >
                {
                    employeeHistoryToDelete && <ConfirmationDialog
                        isOpen={employeeHistoryDeleteDialog}
                        title={this.props.t("delete_asset_employee_history")}
                        message={this.props.t("delete_employee_history")}
                        onClose={() => this.setState({ employeeHistoryDeleteDialog: false })}
                        onConfirm={() => this.setState({ employeeHistoryDeleteDialog: false }, () => this.deleteAssetEmployeeHistory())}
                        closeButtonTitle={this.props.t("close")}
                        confirmButtonTitle={this.props.t("delete")}
                    />
                }
                {
                    locationHistoryToDelete && <ConfirmationDialog
                        isOpen={locationHistoryDialog}
                        title={this.props.t("delete_asset_location_history")}
                        message={this.props.t("delete_location_history")}
                        onClose={() => this.setState({ locationHistoryDialog: false })}
                        onConfirm={() => this.setState({ locationHistoryDialog: false }, () => this.deleteAssetLocationHistory())}
                        closeButtonTitle={this.props.t("close")}
                        confirmButtonTitle={this.props.t("delete")}
                    />
                }
            </Grid >
        );
    }
}

export default withSnackbar(withRouter(withTranslation()(AssetHistory)));
